const rating = {
    large: { size: { value: '{fontSizes.xxxl.value}' } },
    default: { size: { value: '{fontSizes.xl.value}' } },
    small: { size: { value: '{fontSizes.small.value}' } },
    filled: { color: { value: '{colors.secondary.80.value}' } },
    empty: { color: { value: '{colors.background.tertiary.value}' } },
};

export { rating };
